<template>
	<page title="Invoices">
		<invoices-table :invoices="invoices" />
	</page>
</template>
<script>
import Backend from '@/Layouts/Backend'
import Page from '@/Pages/Backend/Components/Page'
import InvoicesTable from '@/Pages/Backend/Invoices/Table'

export default {
	components: { Page, InvoicesTable },
	layout: Backend,
	props: {
		invoices: {
			type: [Array, Object],
			default: () => {},
			required: true
		}
	},
	data () {
		return {
			//
		}
	}
}
</script>
